<!-- Concat.vue -->
<template>
	<div class="ui-concat-wrapper ui-detail-common" v-if="detailInfo">
		<div class="ui-promotions-wrapper ui-detail-common" @click="$router.push({name:'HomeGoodsConsult',query:{goods_id:detailInfo.goods_id}})">
			<!-- header -->
			<div class="promotions-header header">
				<h3>商品咨询<span class="iconfont">&#xe650;</span></h3>
			</div>

		</div>
		<div v-if="config.business_licence" class="ui-promotions-wrapper ui-detail-common" @click="imageVisible=true">
			<!-- header -->
			<div class="promotions-header header">
				<h3>营业执照<span class="iconfont">&#xe650;</span></h3>
			</div>

		</div>
		<mt-popup v-model="imageVisible" popup-transition="popup-fade" class="middle-popup">
			<img :src="config.business_licence">
		</mt-popup>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
		imageVisible:false,
	}
  },

  computed: {
    ...mapState({
		config: state => state.config.config,
      detailInfo: state => state.goodsdetail.detailInfo,
      user: state => state.member.info,
      isOnline: state => state.member.isOnline
    })
  },

  watch: {},

  mounted () {
    this.$nextTick(() => {})
  },

  created () {
	  this.fetchConfig({}).then(
			  response => {
			  },
			  error => {
				  Toast(error.message)
			  }
	  )
  },

  methods: {
	  ...mapActions({
		  fetchConfig: 'fetchConfig'
	  }),
    goSingin () {
      this.$router.push({ name: 'HomeMemberLogin' })
    }
  }
}
</script>

<style lang="scss" scoped>
	.ui-promotions-wrapper {
		height: auto;
		&.ui-detail-common {
			padding: 0;
		}
		.promotions-header {
			padding: 0 0.75rem;
			margin-top: 0.4rem;
			height: 2rem;
			line-height: 2rem;
			background:#fff;
			h3 {
				font-size: 0.7rem;
				color: #333;
				.iconfont{float:right;margin-right:-0.55rem}
			}
			img {
				width:0.25rem;
				height: 0.5rem;
			}
		}

	}
	.middle-popup{width:80%}
	.middle-popup img{max-width:100%}
</style>
